<template lang="pug">
  .propuestas
    //notificacion(:show='this.notificadorShow' :tipo='this.notificadorTipo' :mensaje='this.notificadorMensaje' @close='closeNotif()')
    //button.btn.btn-warning.m-1(v-if="this.add == false" @click.prevent='agregarPropuesta()') Presentar Respuesta
    .card.table-panel(id='' v-if = 'this.add == false')
      .card-header
        h3.card-title
          | Documentos de las Respuestas
      .card-body.table-responsive
        table.table.table-bordered.table-condensed.table-striped.table-hover
          thead
            tr
              th.text-center.w-25 RUC
              th.text-center.w-25 Razon Social
              th.text-center.w-25 Correo Electronico
              th.text-center.w-25 Documento Adjunto
              th.text-center.w-auto Acciones
          tbody()
            tr( v-for='row in listaPropuestas')
              td.text-center  {{row.ruc}}
              td.text-center {{row.razon_social}}
              td.text-center {{row.email_oferente}}
              td.text-center {{row.nombre_archivo}}
              td()
                .btn-group
                  b-dropdown.m-md-1(text='Acciones')
                    b-dropdown-item(@click='showModal(row)') Visualizar Descripcion
                    b-dropdown-item(@click.prevent='obtenerArchivo(row)') Descargar

    b-form(@submit='onSubmit' @reset='onReset')
      b-card(v-if="this.add == true")
        template(#header='')
          h6.mb-0 Presentar Respuesta
        b-card-text
          div
            .form-group.row
              b-form-group#input-group-1.col-sm-1.col-form-label(label='RUC:' label-for='input-ruc')
              .col-sm-3
                b-form-input#input-ruc(v-model='propuesta.ruc' @blur.native ='getDatosProveedor(propuesta.ruc)')
              span.ml-auto(style='color: red;') *
              b-form-group#input-group-2.col-form-label(label='Razon Social:' label-for='input-razon-social')
              .col-sm-4
                b-form-input#input-razon-social(v-model='propuesta.razonSocial' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Correo:' label-for='input-correo')
              .col-sm-7
                b-form-input#input-correo(v-model='propuesta.emailOferente'   type='email' required='')
            .form-group.row
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Respuesta:' label-for='input-propuesta')
              .col-sm-11
                vue-editor(
                  v-model='propuesta.descripcionPropuesta'
                  :editorToolbar="customToolbar"
                )
            br
            .form-group.row(v-if = 'archivoList.length < 1')
              b-form-group#input-group-12.col-sm-2.col-form-label(label='Adjuntar Documento:' label-for='input-documento')
              .col-sm
                .row
                  .col
                    b-form-file#file-default(
                      v-model= 'archivo'
                      placeholder="Seleccionar Archivo"
                      accept=".zip, .rar, .tar"
                    )
                  .col
                    button.btn.btn-primary.border-top(
                      :disabled='this.archivo == null || cargaArchivo '
                      @click.prevent='cargarArchivo()'
                    ) {{cargaArchivo ? 'Subiendo Archivo...' : 'Subir Archivo'}}

            table.table.table-bordered.table-condensed.table-striped.table-hover(v-if = 'archivoList.length > 0')
              thead
                tr
                  th.text-center.w-25 Nombre
                  th.text-center.w-25 Fecha Adjunto
                  th.text-center.w-25 Acciones
              tbody()
                tr( v-for='(row,index) in archivoList')
                  td.text-center {{row.name}}
                  td.text-center {{row.lastModifiedDate ? convertDate(row.lastModifiedDate) : row.fechaArchivo}}
                  td.text-center
                    .btn-group
                      b-dropdown.m-md-1(text='Acciones')
                        b-dropdown-item(@click.prevent='obtenerArchivo(row)') Descargar
                        b-dropdown-item(@click.prevent='borrarArchivo(row)') Borrar

            div.float-right
              button.btn.btn-secondary.m-1(type='reset' variant='danger') Volver
            button.btn.btn-warning.m-1(type='submit' variant='primary') Enviar
            //b-button(type='submit' variant='primary') Submit
            //b-button(type='reset' variant='danger') Reset

    b-modal#modal-1(v-model="modalShow" size="lg" :ok-only='true' title = 'Descripcion de la Propuesta')
      vue-editor(
          v-model='descripcionPropuesta'
          :editorToolbar="customToolbar"
          :disabled ='true'
        )



</template>

<script>

import {VueEditor} from "vue2-editor";

import {HTTP} from "../http";
import functions from '../mixins/functions'


export default {
  name: "PropuestaTab",
  mixins: [functions],
  components: {
    VueEditor
  },
  props: {
    rfi_id: {
      type: String,
    }
  },
  data() {
    return {
      add: Boolean,
      propuesta: {},
      listaPropuestas: {},
      archivoList: [],
      archivo: null,
      descripcionPropuesta : "",
      modalShow: false,
      cargaArchivo: false,
      datosProveedor: {},

      requiredFields: [
        'descripcionPropuesta'
      ],


      customToolbar: [[{
        header: [false, 1, 2, 3, 4, 5, 6]
      }], ["bold", "italic", "underline", "strike"], // toggled buttons
        [{
          align: ""
        }, {
          align: "center"
        }, {
          align: "right"
        }, {
          align: "justify"
        }], ["blockquote", "code-block"], [{
          list: "ordered"
        }, {
          list: "bullet"
        }, {
          list: "check"
        }], [{
          indent: "-1"
        }, {
          indent: "+1"
        }], // outdent/indent
        [{
          color: []
        }, {
          background: []
        }], // dropdown with defaults from theme
        ["clean"] // remove formatting button
      ],

    }
  },
  async created(){
    this.add = false ;
    try {
      this.listaPropuestas = (await HTTP.get('/respuesta/list/',{ params: {solicitudId: this.rfi_id}})).data
    } catch (error) {
      //console.log(error);
    }
  },

  methods: {
    onSubmit(event) {
      this.save(this.propuesta)
      event.preventDefault()
    },
    onReset(event) {
      event.preventDefault()
      this.volver();
      // Trick to reset/clear native browser form validation state

    },

    getDatosProveedor:async function(ruc) {
      this.datosProveedor = (await HTTP.get('/invitado/getProveedor/'+ruc)).data
      this.propuesta.razonSocial = this.datosProveedor.razon_social
      this.propuesta.emailOferente = this.datosProveedor.email
      this.add = false
      this.$nextTick(()=>{
        this.add = true
      })
    },
    agregarPropuesta: function () {
      this.add = true;
    },
    volver: function () {
      this.add = false;
      this.limpiar()
    },
    limpiar: function () {
      this.propuesta = {};
      this.archivoList = [];
      this.archivo = null;
    },
    showModal: function (instance) {
      console.log(instance.descripcion_propuesta)
      this.descripcionPropuesta = instance.descripcion_propuesta;
      return this.modalShow = true;
    },

    save: async function (instance) {
      instance.rfiId = this.rfi_id;
      console.log(instance)
      if(!this._checkRequired(instance, this.requiredFields)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la propuesta'});
      } else {
        instance.archivos = []
        this.archivoList.forEach(archivo => {
          let fileToSave = {
            name: archivo.name,
            type: archivo.type,
            size: archivo.size,
            tmpFilePath: archivo.tmpFilePath
          }
          instance.archivos.push(fileToSave)
        })
        try {
          await (HTTP.post('/respuesta/create', instance));
          this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha enviado la Propuesta'});
          this.limpiar()
          this.listaPropuestas = (await HTTP.get('/respuesta/list/',{ params: {solicitudId: this.rfi_id}})).data
          this.add = false;
          window.scrollTo(0, 0);
        } catch (error) {
          console.log(error);
          this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al enviar la Propuesta'});
          window.scrollTo(0, 0);

        }
      }
    },
    convertDate: function(fecha) {
      if(fecha){
        let date = JSON.stringify(fecha)
        date = date.slice(1,11)
        return date
      }
      return null
    },
    async getArchivos() {
      this.archivoList = (await HTTP.get('/archivo/listar', {params: {solicitudId: this.id}})).data;
    },
    cargarArchivo: function () {
      let formData = new FormData()
      formData.append('archivo', this.archivo)
      this.cargaArchivo = true;
      HTTP.post('/archivo/subir', formData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
      }).then(result => {
        this.archivo.tmpFilePath = result.data.tmpFilePath
        this.archivoList.push(this.archivo)
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo recibido correctamente'});
        this.archivo = null
      }).catch(error => {
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al subir el archivo. ' + error.response.data});
      }).finally(() => {
        this.cargaArchivo = false;
      })
    },
    obtenerArchivo(instance) {
      console.log(instance.documento_id)
      HTTP.get('/archivo/obtenerPropuestaArchivo', {params: {documentoId: instance.documento_id}, responseType: 'blob'})
          .then(result => {
            this.handleResponseArchivo(result.data, instance.nombre_archivo)
          })
          .catch(error => {
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Obtener el archivo. ' + error.response.data});
          })
    },
    borrarArchivo: function (instance) {
      // this.$delete(this.archivoList, index)
      HTTP.delete('/archivo/eliminar', {params: {documentoId: instance.id}})
          .then(async result => {
            console.log(result)
            window.scrollTo(0,0);
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo eliminado correctamente'});
            await this.getArchivos(); // Se actualiza la lista de archivos
          })
          .catch(error => {
            console.log(error)
            window.scrollTo(0,0);
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Borrar el archivo'});
          })
    },
    handleResponseArchivo(blobData, name) {
      let fileURL = window.URL.createObjectURL(blobData);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  }
}
</script>

<style scoped>
.modal-large {
  width: 90vw;
}
</style>
